var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { AccessUnitNode, AccessUnitService, Period, Role, RoleSetting } from './accessunit.service';
var AccessUnitComponent = /** @class */ (function (_super) {
    __extends(AccessUnitComponent, _super);
    function AccessUnitComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.all_events = [
            'init.jstree',
            'loading.jstree',
            'loaded.jstree',
            'ready.jstree',
            'load_node.jstree',
            'load_all.jstree',
            'model.jstree',
            'redraw.jstree',
            'before_open.jstree',
            'open_node.jstree',
            'after_open.jstree',
            'close_node.jstree',
            'after_close.jstree',
            'open_all.jstree',
            'close_all.jstree',
            'enable_node.jstree',
            'disable_node.jstree',
            'hide_node.jstree',
            'show_node.jstree',
            'hide_all.jstree',
            'show_all.jstree',
            'activate_node.jstree',
            'hover_node.jstree',
            'dehover_node.jstree',
            'select_node.jstree',
            'changed.jstree',
            'deselect_node.jstree',
            'select_all.jstree',
            'deselect_all.jstree',
            'set_state.jstree',
            'refresh.jstree',
            'refresh_node.jstree',
            'set_id.jstree',
            'set_text.jstree',
            'create_node.jstree',
            'rename_node.jstree',
            'delete_node.jstree',
            'move_node.jstree',
            'copy_node.jstree',
            'cut.jstree',
            'copy.jstree',
            'paste.jstree',
            'clear_buffer.jstree',
            'set_theme.jstree',
            'show_stripes.jstree',
            'hide_stripes.jstree',
            'show_dots.jstree',
            'hide_dots.jstree',
            'show_icons.jstree',
            'hide_icons.jstree',
            'show_ellipsis.jstree',
            'hide_ellipsis.jstree',
            'disable_checkbox.jstree',
            'enable_checkbox.jstree',
            'check_node.jstree',
            'uncheck_node.jstree',
            'check_all.jstree',
            'uncheck_all.jstree',
            'show_contextmenu.jstree',
            'search.jstree',
            'clear_search.jstree',
            'state_ready.jstree'
        ];
        _this.plugins = [
            'wholerow',
            'checkbox',
            'search',
            'contextmenu',
            'types'
        ];
        _this.limit = 10;
        _this.readonly = false;
        _this.search = false;
        _this.tree_data = new Subject();
        _this.ignore_events = ['hover_node.jstree', 'dehover_node.jstree'];
        _this.is_control_tree_monitor = false;
        _this.units_label = '';
        _this.roles_data = [];
        _this.role_node = [];
        _this.role_error = '';
        _this.parent_node_id = null;
        _this.seq = 1;
        _this.toggle = false;
        return _this;
    }
    AccessUnitComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.component.params && this.component.params.limit) {
            this.limit = this.component.params.limit;
        }
        if (this.component.params && typeof this.component.params.readonly !== 'undefined') {
            this.readonly = this.component.params.readonly;
        }
    };
    AccessUnitComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
    };
    AccessUnitComponent.prototype.ngAfterViewInit = function () {
        this.element = this.treeElement.nativeElement;
        this.modal = this.remodalElement.nativeElement;
        this.init();
    };
    AccessUnitComponent.prototype.tree = function () {
        return $(this.element).jstree(true);
    };
    ;
    AccessUnitComponent.prototype.init = function () {
        var _this = this;
        var self = this;
        this.tree_data.subscribe(function (data) {
            var coreData = function ($node, cb) {
                if ($node.id === '#') {
                    cb(data);
                }
                else {
                    var load_data = self.onLoadNode($node);
                    cb(load_data);
                }
            };
            var tree = self.tree();
            if (!tree) {
                $(self.element).jstree({
                    core: {
                        check_callback: true,
                        data: coreData,
                        themes: {
                            icons: false
                        }
                    },
                    checkbox: {
                        keep_selected_style: false,
                        whole_node: false,
                        tie_selection: false,
                        three_state: false
                    },
                    contextmenu: {
                        items: function ($node) {
                            if (!$node.data.grant || self.readonly) {
                                return;
                            }
                            var role_menu = {
                                role: {
                                    separator_before: false,
                                    separator_after: true,
                                    label: self.msgSnapshot['AccessUnitComponent.contextmenu.role'],
                                    action: function (obj) {
                                        self.onRoleNode($node);
                                    }
                                }
                            };
                            var default_menu = {
                                default: {
                                    separator_before: false,
                                    separator_after: true,
                                    label: self.msgSnapshot['AccessUnitComponent.contextmenu.default'],
                                    action: function (obj) {
                                        self.onDefaultNode($node);
                                    }
                                }
                            };
                            var common_menu = {
                                check: {
                                    separator_before: false,
                                    separator_after: false,
                                    label: self.msgSnapshot['AccessUnitComponent.contextmenu.check'],
                                    action: function (obj) {
                                        self.onChildCheckNode($node);
                                    }
                                },
                                uncheck: {
                                    separator_before: false,
                                    separator_after: false,
                                    label: self.msgSnapshot['AccessUnitComponent.contextmenu.uncheck'],
                                    action: function (obj) {
                                        self.onChildUncheckNode($node);
                                    }
                                }
                            };
                            var menu = common_menu;
                            if ($node.state.checked) {
                                if ($node.data.disable) {
                                    menu = Object.assign({}, role_menu, common_menu);
                                }
                                else {
                                    menu = Object.assign({}, role_menu, default_menu, common_menu);
                                }
                            }
                            return menu;
                        }
                    },
                    search: {
                        show_only_matches: true
                    },
                    types: {
                        more: {
                            valid_children: []
                        }
                    },
                    plugins: _this.plugins
                });
            }
            else {
                tree.settings.core.data = coreData;
                tree.redraw(true);
                tree.refresh(true, true);
            }
        });
        var events = this.all_events.filter(function (element) {
            return self.ignore_events.indexOf(element) == -1;
        });
        $(this.element).on(events.join(' '), function (e, data) {
            self.onEvent(e, e.type, data);
        });
    };
    AccessUnitComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    AccessUnitComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = (mode === 'confirm') ? true : false;
        if (typeof this.org_data !== 'undefined' && this.org_data instanceof Array) {
            this.onSearchClear();
        }
    };
    AccessUnitComponent.prototype.onSubscribe = function (rec) {
        if (typeof rec.units !== 'undefined' && rec.units instanceof Array) {
            this.org_data = rec.units;
            this.onSearchClear();
            this.setCompRec();
        }
        if (typeof rec.roles !== 'undefined' && rec.roles instanceof Array) {
            this.org_roles_data = rec.roles;
        }
    };
    AccessUnitComponent.prototype.applyToTreeData = function (recs) {
        var node = jsonpath.value(recs, '$..[?(@.default==true)]');
        if (node) {
            this.default_node_id = node.id;
        }
        this.is_control_tree_monitor = true;
        this.tree_data.next(this.createTreeData(recs));
        this.is_control_tree_monitor = false;
    };
    AccessUnitComponent.prototype.createTreeData = function (recs) {
        var data = [];
        for (var _i = 0, recs_1 = recs; _i < recs_1.length; _i++) {
            var rec = recs_1[_i];
            data.push(new UnitNode(rec, this.readonly, this.search));
            if (data.length == this.limit && this.limit < recs.length && !this.search) {
                data.push(this.createMoreNode());
                break;
            }
        }
        return data;
    };
    AccessUnitComponent.prototype.onEvent = function (e1, e2, rec) {
        if (e2 === 'check_node') {
            this.beforeEvent = e2;
        }
        else if (e2 === 'uncheck_node') {
            this.beforeEvent = e2;
        }
        else if (e2 === 'activate_node') {
            if (this.beforeEvent === 'check_node') {
                this.beforeEvent = null;
                this.onCheckNode(rec);
            }
            else if (this.beforeEvent === 'uncheck_node') {
                this.beforeEvent = null;
                this.onUncheckNode(rec);
            }
        }
        else if (e2 === 'select_node') {
            if (rec.node.type === 'more' && rec.event.type === 'click') {
                this.onMoreNode(rec);
            }
        }
        else if (e2 === 'load_node') {
            if (this.search) {
                this.search = false;
                this.tree().search(this.treeSearch);
            }
        }
    };
    AccessUnitComponent.prototype.applyToOrgData = function (rec) {
        var node = jsonpath.value(this.org_data, '$..[?(@.id==' + rec.id + ')]');
        if (node != null) {
            node.access = rec.state.checked;
            node.default = false;
            if (rec.a_attr.class.match('checkTree_default')) {
                node.default = true;
            }
            node.roles = rec.data.roles;
        }
        this.setCompRec();
    };
    AccessUnitComponent.prototype.applyToOrgDataChild = function (id, data) {
        var node = jsonpath.value(this.org_data, '$..[?(@.id==' + id + ')]');
        this.applyToOrgDataChildRec(node, data);
        this.setCompRec();
    };
    AccessUnitComponent.prototype.applyToOrgDataChildRec = function (rec, data) {
        for (var _i = 0, _a = rec.children; _i < _a.length; _i++) {
            var child = _a[_i];
            if (child.grant) {
                for (var _b = 0, _c = Object.keys(data); _b < _c.length; _b++) {
                    var key = _c[_b];
                    child[key] = data[key];
                }
            }
            this.applyToOrgDataChildRec(child, data);
        }
    };
    AccessUnitComponent.prototype.setCompRec = function () {
        var count = (jsonpath.query(this.org_data, '$..[?(@.access==true)]') || []).length;
        this.units_label = this.msgSnapshot['au.COMPONENT.AccessUnitComponent.label.units'].replace(/\{\{count\}\}/, count.toString());
        this.action.setCompRec(this.componentName, { units: this.org_data });
        this.logger.debug('org_data:', this.org_data);
    };
    AccessUnitComponent.prototype.onCheckNode = function (rec) {
        this.role_node.push({ id: rec.node.id, edit: false });
        this.openRemodal();
    };
    AccessUnitComponent.prototype.onUncheckNode = function (rec) {
        rec.node.text = rec.node.data.label;
        rec.node.data.roles = [];
        this.applyToOrgData(rec.node);
        this.tree().redraw(true);
    };
    AccessUnitComponent.prototype.onDefaultNode = function (rec) {
        var old_default_id = this.default_node_id;
        this.default_node_id = rec.id;
        if (old_default_id != null) {
            var node = this.tree().get_node(old_default_id);
            if (node) {
                this.setDefault(node);
            }
            else {
                node = jsonpath.value(this.org_data, '$..[?(@.id==' + old_default_id + ')]');
                node.default = false;
                this.setCompRec();
            }
        }
        this.setDefault(rec);
        this.tree().redraw(true);
    };
    AccessUnitComponent.prototype.setDefault = function (rec) {
        var attr_class = [];
        if (this.default_node_id === rec.id) {
            attr_class.push('checkTree_default');
        }
        if (rec.data.disable) {
            attr_class.push('checkTree_disabled');
        }
        if (!rec.data.grant) {
            attr_class.push('checkTree_locked');
        }
        rec.a_attr.class = attr_class.join(' ');
        this.applyToOrgData(rec);
    };
    AccessUnitComponent.prototype.onChildCheckNode = function (rec) {
        this.setChecked(rec, true);
        this.tree().redraw(true);
        this.openRemodal();
        this.parent_node_id = rec.id;
    };
    AccessUnitComponent.prototype.onChildUncheckNode = function (rec) {
        this.setChecked(rec, false);
        this.tree().redraw(true);
        this.applyToOrgDataChild(rec.id, { access: false, roles: [] });
    };
    AccessUnitComponent.prototype.setChecked = function (rec, boolflg) {
        for (var _i = 0, _a = rec.children_d; _i < _a.length; _i++) {
            var child = _a[_i];
            var node = this.tree().get_node(child);
            if (!node.data.grant) {
                continue;
            }
            if (boolflg) {
                this.role_node.push({ id: node.id, edit: node.state.checked });
            }
            else {
                node.text = node.data.label;
                node.data.roles = [];
            }
            node.state.checked = boolflg;
        }
    };
    AccessUnitComponent.prototype.onLoadNode = function (rec) {
        var recs = jsonpath.value(this.org_data, '$..[?(@.id==' + rec.id + ')]');
        recs = recs.children;
        return this.createTreeData(recs);
    };
    AccessUnitComponent.prototype.onMoreNode = function (rec) {
        var node = rec.node;
        var parent_node = this.tree().get_node(node.parent);
        var scrollTop = $(window).scrollTop();
        var page = node.data.page;
        var offset = page * this.limit;
        var recs = (node.parent === '#' ? this.org_data : jsonpath.value(this.org_data, '$..[?(@.id==' + node.parent + ')]').children);
        var count = 0;
        this.tree().delete_node(node);
        for (var i = offset; i < recs.length; i++) {
            this.tree().create_node(parent_node, new UnitNode(recs[i], this.readonly, this.search));
            count++;
            if (count == this.limit && offset + this.limit < recs.length && !this.search) {
                this.tree().create_node(parent_node, this.createMoreNode(page + 1));
                break;
            }
        }
        $(window).scrollTop(scrollTop);
    };
    AccessUnitComponent.prototype.createMoreNode = function (page) {
        if (page === void 0) { page = 1; }
        return new UnitNode({ more: true, page: page }, this.readonly, this.search, this.msgSnapshot);
    };
    AccessUnitComponent.prototype.openRemodal = function () {
        this.remodal = $(this.modal).remodal({ hashTracking: false, closeOnEscape: false, closeOnOutsideClick: false });
        this.remodal.open();
    };
    AccessUnitComponent.prototype.closeRemodal = function () {
        this.roles_data = [];
        this.role_node = [];
        this.role_error = '';
        this.parent_node_id = null;
        this.tree().redraw(true);
        this.remodal.close();
    };
    AccessUnitComponent.prototype.onRoleNode = function (rec) {
        this.seq = 1;
        for (var _i = 0, _a = rec.data.roles; _i < _a.length; _i++) {
            var role = _a[_i];
            for (var _b = 0, _c = role.periods; _b < _c.length; _b++) {
                var period = _c[_b];
                this.roles_data.push({
                    $seq: this.seq++,
                    id: role.id,
                    label: role.label,
                    set_period: (period.start_date || period.end_date ? true : false),
                    unit_role_m_id: period.id,
                    start_date: period.start_date,
                    end_date: period.end_date,
                    error: []
                });
            }
        }
        this.role_node.push({ id: rec.id, edit: true });
        this.openRemodal();
    };
    AccessUnitComponent.prototype.onAdd = function () {
        this.roles_data.push(Object.assign(new RoleSetting(), { $seq: this.seq++ }));
    };
    AccessUnitComponent.prototype.onDelete = function (index) {
        this.roles_data.splice(index, 1);
    };
    AccessUnitComponent.prototype.onChange = function (e1, e2, index) {
        if (e2 === 'role') {
            this.roles_data[index].label = e1.target.options[e1.target.selectedIndex].text;
            this.roles_data[index].unit_role_m_id = null;
        }
        else if (e2 === 'setPeriod') {
            if (!e1.target.checked) {
                this.roles_data[index].start_date = '';
                this.roles_data[index].end_date = '';
                this.roles_data[index].error = [];
            }
        }
    };
    AccessUnitComponent.prototype.onClickDate = function (key, val, index) {
        this.roles_data[index][key] = val;
    };
    AccessUnitComponent.prototype.onCancel = function () {
        for (var _i = 0, _a = this.role_node; _i < _a.length; _i++) {
            var n = _a[_i];
            if (!n.edit) {
                this.setChecked({ children_d: [n.id] }, false);
            }
        }
        this.closeRemodal();
    };
    AccessUnitComponent.prototype.onSubmit = function () {
        var r = {};
        var roles = [];
        var roles_label = [];
        var err_flg = false;
        for (var _i = 0, _a = this.roles_data; _i < _a.length; _i++) {
            var role = _a[_i];
            if (role.id) {
                role.error = [];
                if (role.start_date && role.end_date && new Date(role.start_date).getTime() > new Date(role.end_date).getTime()) {
                    role.error.push(this.msgSnapshot['AccessUnitComponent.modal.error.period']);
                }
                if (role.error.length) {
                    err_flg = true;
                    continue;
                }
                var period_label = '';
                var key = 'role-' + role.id;
                if (!r[key]) {
                    r[key] = new Role();
                }
                r[key].id = role.id;
                r[key].label = role.label;
                var p = new Period();
                if (role.unit_role_m_id) {
                    p.id = role.unit_role_m_id;
                }
                if (role.start_date) {
                    p.start_date = role.start_date;
                    period_label += role.start_date;
                }
                if (role.start_date || role.end_date) {
                    period_label += '-';
                }
                if (role.end_date) {
                    p.end_date = role.end_date;
                    period_label += role.end_date;
                }
                r[key].periods.push(p);
                roles_label.push(role.label + (period_label ? '[' + period_label + ']' : ''));
            }
        }
        if (err_flg) {
            return;
        }
        for (var key in r) {
            roles.push(r[key]);
        }
        this.logger.debug('roles:', roles);
        if (roles.length > 0) {
            for (var _b = 0, _c = this.role_node; _b < _c.length; _b++) {
                var n = _c[_b];
                var node = this.tree().get_node(n.id);
                node.text = node.data.label + ' <span class="checkTree_roles">' + roles_label.join(', ') + '</span>';
                node.data.roles = roles;
                if (this.parent_node_id === null) {
                    this.applyToOrgData(node);
                }
            }
            if (this.parent_node_id !== null) {
                this.applyToOrgDataChild(this.parent_node_id, { access: true, roles: roles });
            }
            this.closeRemodal();
        }
        else {
            this.role_error = this.msgSnapshot['AccessUnitComponent.modal.error.role'];
        }
    };
    AccessUnitComponent.prototype.onSearch = function () {
        if (!this.treeSearch) {
            return;
        }
        this.search = true;
        this.applyToTreeData(this.org_data);
    };
    AccessUnitComponent.prototype.onSearchClear = function () {
        this.search = false;
        this.treeSearch = '';
        if (this.tree()) {
            this.tree().clear_search();
        }
        this.applyToTreeData(this.org_data);
    };
    AccessUnitComponent.prototype.switchToggle = function () {
        this.toggle = !this.toggle;
    };
    AccessUnitComponent.prototype.trackByItem = function (index, item) {
        return item.$seq;
    };
    AccessUnitComponent.prototype.trackByRole = function (index, role) {
        return role.id;
    };
    AccessUnitComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.tree_data.unsubscribe();
        if ($(this.modal).parent().hasClass('remodal-wrapper')) {
            this.remodal.destroy();
        }
    };
    AccessUnitComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'accessunit',
                    template: "<form id=\"{{ componentName }}\">\n  <div class=\"filter\">\n    <p class=\"filter_trigger\">\n      <span [class.open]=\"toggle\" (click)=\"switchToggle()\">{{ units_label }}</span>\n    </p>\n    <div class=\"filter_property filter_property_toggle -p-2\" [style.display]=\"toggle ? 'block': 'none'\">\n      <div class=\"row\">\n        <div class=\"col-sm-12\">\n          <p *ngIf=\"!readonly\">{{ (msg | async)['AccessUnitComponent.label.note'] }}</p>\n          <ul [key]=\"'btn'\" buttonDir>\n            <li [key]=\"'btn'\" buttonDir>\n              <input type=\"text\" class=\"checkTree_searchInput\" placeholder=\"{{ (msg | async)['Search...'] }}\" name=\"treeSearch\" [(ngModel)]=\"treeSearch\">\n            </li>\n            <li [key]=\"'btn'\" buttonDir>\n              <item-btn [key]=\"'btn'\" [btn]=\"{\n                                    type: 'button',\n                                    event: componentName + '#Button#search',\n                                    caption: (msg | async)['SearchConditionComponent.button.search'],\n                                    params: {btnClass: {sm: true}}\n                                }\" (clickBtn)=\"onSearch()\"></item-btn>\n            </li>\n            <li [key]=\"'btn'\" buttonDir>\n              <item-btn [key]=\"'btn'\" [btn]=\"{\n                                    type: 'button',\n                                    event: componentName + '#Button#searchClear',\n                                    caption: (msg | async)['SearchConditionComponent.button.clear'],\n                                    params: {btnClass: {sm: true, type: 'delete'}}\n                                }\" (clickBtn)=\"onSearchClear()\"></item-btn>\n            </li>\n          </ul>\n          <div #tree></div>\n        </div>\n      </div>\n    </div>\n  </div>\n</form>\n\n<!-- remodal -->\n<div class=\"remodal\" id=\"{{ componentName + '#Remodal#Roles' }}\" #remodal>\n  <div class=\"remodal_whitebg\">\n    <p class=\"sectionHeading\">{{ (msg | async)['AccessUnitComponent.modal.title'] }}</p>\n    <div class=\"row -mt-3\">\n      <div class=\"col-sm-12\">\n        <div class=\"tableWrapper\">\n          <table class=\"tableWrapper_table\">\n            <thead>\n            <tr data-href=\"#\">\n              <th scope=\"col\"><a class=\"-fixed\">{{ (msg | async)['AccessUnitComponent.modal.th.role'] }}</a></th>\n              <th scope=\"col\"><a class=\"-fixed\"></a></th>\n              <th scope=\"col\"><a class=\"-fixed\">{{ (msg | async)['AccessUnitComponent.modal.th.period'] }}</a></th>\n              <th scope=\"col\"><a class=\"-fixed\"></a></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let role of roles_data; let index = index; trackBy: trackByItem\" data-href=\"#\" class=\"tr_cursorDefault\">\n              <td>\n                <dl class=\"form\">\n                  <dt></dt>\n                  <dd class=\"form_dd\">\n                    <ul>\n                      <li class=\"form_li\">\n                        <select class=\"formSelect formSelect-inline\" [(ngModel)]=\"role.id\" (change)=\"onChange($event, 'role', index)\">\n                          <option [value]=\"\"></option>\n                          <option *ngFor=\"let option of org_roles_data; trackBy: trackByRole\" [value]=\"option.id\">{{ option.label }}</option>\n                        </select>\n                      </li>\n                    </ul>\n                  </dd>\n                </dl>\n              </td>\n              <td>\n                <dl class=\"form\">\n                  <dt></dt>\n                  <dd class=\"form_dd\">\n                    <ul>\n                      <li class=\"form_li\">\n                        <input class=\"formInputCheckbox\" type=\"checkbox\" id=\"setPeriod-{{ role.$seq }}\" [(ngModel)]=\"role.set_period\" (change)=\"onChange($event, 'setPeriod', index)\">\n                        <label class=\"formInputCheckboxLabel formInputCheckboxLabel-inline\" for=\"setPeriod-{{ role.$seq }}\">{{ (msg | async)['AccessUnitComponent.modal.checkbox.period'] }}</label>\n                      </li>\n                    </ul>\n                  </dd>\n                </dl>\n              </td>\n              <td>\n                <dl class=\"form\">\n                  <dt></dt>\n                  <dd class=\"form_dd\">\n                    <ul *ngIf=\"role.set_period\">\n                      <li class=\"form_li form_li-w100\">\n                        <kts-column-date [key]=\"'forminline'\" [col]=\"{\n                          key: 'start_date-' + role.$seq,\n                          controlType: 'date',\n                          params: { range: { from: 'start_date-' + role.$seq, to: 'end_date-' + role.$seq }, placeholder: '...' }\n                        }\" [val]=\"role.start_date\" [msg]=\"(msg | async)\" (changeVal)=\"onClickDate('start_date', $event.val, index)\"></kts-column-date>\n                      </li>\n                      <li class=\"form_li\">~</li>\n                      <li class=\"form_li form_li-w100\">\n                        <kts-column-date [key]=\"'forminline'\" [col]=\"{\n                          key: 'end_date-' + role.$seq,\n                          controlType: 'date',\n                          params: { range: { from: 'start_date-' + role.$seq, to: 'end_date-' + role.$seq }, placeholder: '...' }\n                        }\" [val]=\"role.end_date\" [msg]=\"(msg | async)\" (changeVal)=\"onClickDate('end_date', $event.val, index)\"></kts-column-date>\n                      </li>\n                    </ul>\n                    <ul *ngIf=\"!role.set_period\">\n                      <li class=\"form_li form_li-w100\"><input class=\"formInputText formInputText-inline\" type=\"text\" placeholder=\"...\" [disabled]=\"true\"></li>\n                      <li class=\"form_li\">~</li>\n                      <li class=\"form_li form_li-w100\"><input class=\"formInputText formInputText-inline\" type=\"text\" placeholder=\"...\" [disabled]=\"true\"></li>\n                    </ul>\n                  </dd>\n                </dl>\n                <p *ngFor=\"let error of role.error\" class=\"-comment\">{{ error }}</p>\n              </td>\n              <td>\n                <a href=\"javascript:void(0);\" (click)=\"onDelete(index)\">{{ (msg | async)['AccessUnitComponent.modal.delete'] }}</a>\n              </td>\n            </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n    <p>\n      <button class=\"addBtn\" type=\"button\" (click)=\"onAdd()\"></button>\n    </p>\n    <span *ngIf=\"role_error\" class=\"-comment\">{{ role_error }}</span>\n  </div>\n  <div class=\"remodal_btns\">\n    <ul class=\"remodal_btns_group\">\n      <li>\n        <button data-remodal-action=\"cancel\" type=\"reset\" class=\"remodal_btns_group-cancel\" (click)=\"onCancel()\">{{ (msg | async)['AccessUnitComponent.modal.button.cancel'] }}</button>\n      </li>\n      <li>\n        <button type=\"submit\" class=\"remodal_btns_group-ok\" (click)=\"onSubmit()\">{{ (msg | async)['AccessUnitComponent.modal.button.ok'] }}</button>\n      </li>\n    </ul>\n  </div>\n</div>\n<!-- /remodal -->\n"
                }] }
    ];
    /** @nocollapse */
    AccessUnitComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: AccessUnitService }
    ]; };
    AccessUnitComponent.propDecorators = {
        treeElement: [{ type: ViewChild, args: ['tree',] }],
        remodalElement: [{ type: ViewChild, args: ['remodal',] }]
    };
    return AccessUnitComponent;
}(ContentBaseComponent));
export { AccessUnitComponent };
var UnitNode = /** @class */ (function (_super) {
    __extends(UnitNode, _super);
    function UnitNode(rec, disabled, search, msg) {
        if (msg === void 0) { msg = {}; }
        var _this = _super.call(this, rec) || this;
        if (rec['id'] != null) {
            _this.id = rec.id;
        }
        if (rec['access'] != null) {
            _this.state.checked = rec.access;
        }
        var attr_class = [];
        if (rec['disable'] != null && rec['disable']) {
            attr_class.push('checkTree_disabled');
        }
        if (rec['default'] != null && rec['default']) {
            attr_class.push('checkTree_default');
        }
        if (rec['grant'] != null && !rec['grant']) {
            attr_class.push('checkTree_locked');
        }
        _this.a_attr.class = attr_class.join(' ');
        if (rec != null) {
            if (rec['children'] != null) {
                if (search) {
                    _this.children = [];
                    for (var _i = 0, _a = rec['children']; _i < _a.length; _i++) {
                        var child = _a[_i];
                        _this.children.push(new UnitNode(child, disabled, search));
                    }
                }
                else if (rec['children'].length > 0) {
                    _this.children = true;
                }
            }
            var text = rec.label;
            if (!rec['grant']) {
                text = '<img src="img/icon_locked.svg" alt="" width="14">' + rec.label;
            }
            if (rec['roles'] instanceof Array) {
                var roles_label = [];
                for (var _b = 0, _c = rec.roles; _b < _c.length; _b++) {
                    var role = _c[_b];
                    for (var _d = 0, _e = role.periods; _d < _e.length; _d++) {
                        var period = _e[_d];
                        var period_label = '';
                        if (period.start_date) {
                            period_label += period.start_date;
                        }
                        if (period.start_date || period.end_date) {
                            period_label += '-';
                        }
                        if (period.end_date) {
                            period_label += period.end_date;
                        }
                        roles_label.push(role.label + (period_label ? '[' + period_label + ']' : ''));
                    }
                }
                text += ' <span class="checkTree_roles">' + roles_label.join(', ') + '</span>';
            }
            _this.text = text;
        }
        if (rec['more']) {
            _this.text = '<a href="javascript:void(0);">' + msg['au.COMPONENTS.label.tree.more'] + '</a>';
            _this.type = 'more';
            _this.li_attr.class = 'checkTree_more';
        }
        else {
            _this.state.disabled = disabled;
        }
        return _this;
    }
    return UnitNode;
}(AccessUnitNode));
//# sourceMappingURL=accessunit.component.js.map